import React from 'react';
import { Box, Button, Text } from '@wix/design-system';
import styles from './PostIdeasWidget.scss';
import { navigateTo, PageComponentId } from '@wix/business-manager-api';
const navigateToAiSidebarToolsPostCreation = payload => {
  navigateTo({
    contextData: {
      appState: 'create-post?tab=ai-post-creator'
    },
    pageComponentId: PageComponentId.SocialBlog,
    payload
  });
};
const PostIdea = _ref => {
  let {
    title,
    description
  } = _ref;
  const [showButtons, setShowButtons] = React.useState(false);
  return /*#__PURE__*/React.createElement("div", {
    onMouseOver: () => {
      setShowButtons(true);
    },
    onMouseLeave: () => {
      setShowButtons(false);
    },
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.idea
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "small",
    marginBottom: "tiny"
  }, title)), showButtons && /*#__PURE__*/React.createElement("div", {
    className: styles.overlay
  }, /*#__PURE__*/React.createElement(Button, {
    skin: "inverted",
    onClick: () => {
      navigateToAiSidebarToolsPostCreation(`${title} \n${description}`);
    },
    size: "small"
  }, "Create post with AI")));
};
export const PostIdeasWidget = _ref2 => {
  let {
    data: {
      postIdeas
    }
  } = _ref2;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, "Select one of these ideas:"), postIdeas.map((_ref3, index) => {
    let {
      title,
      description
    } = _ref3;
    return /*#__PURE__*/React.createElement(PostIdea, {
      key: index,
      title: title,
      description: description
    });
  }));
};
export const POST_IDEAS_WIDGET = 'POST_IDEAS_WIDGET';

/** type ToolExecuteResponse.WidgetSpec (Assistant tool that respond with widget) example:
 *
 * widget: {
    widget: 'POST_IDEAS_WIDGET',
    data: {
      postIdeas:[
        {
          title:"The Roswell Incident: Uncovering the Truth Behind the Legendary UFO Crash",
          description:"Investigate the infamous Roswell incident and its implications for UFO conspiracy theories."
        },
        {
          title:"Government Black Projects: Classified UFO Research and Technology",
          description:"Explore the hidden world of government black projects focused on UFO research and advanced technology."
        },
        {
          title:"Ancient Astronaut Theory: Extraterrestrial Influence on Human History",
          description:"Discuss the controversial theory that suggests ancient civilizations were influenced by extraterrestrial beings."
        }
      ]
    }
  }
*/
//# sourceMappingURL=PostIdeasWidget.js.map